export default {"src":"/_next/static/media/deco_checkout_discover.84c3cd47.svg","height":34,"width":55,"blurWidth":0,"blurHeight":0};